import { useState } from "react";
import Reveal from "./Reveal";
import Lightbox from "./Lightbox";
import panels from "../data/collection";

// Horizontal strip of the Culture Antique antique-gold product panels.
export default function SignatureCollection() {
  const [active, setActive] = useState(null);
  const items = panels.map((p) => ({ type: "image", src: p.src }));

  return (
    <section className="border-y border-gold/15 bg-cream py-16 md:py-24">
      <div className="container-luxe">
        <Reveal className="mb-10 text-center md:mb-14">
          <p className="eyebrow mb-4">The Signature Antique Gold</p>
          <h2 className="section-title">A closer look</h2>
          <p className="mx-auto mt-4 max-w-xl font-sans text-sm font-light leading-relaxed text-charcoal/60 md:text-base">
            Explore the detail and dimension of our hand-crafted antique gold —
            tap any panel to view it up close.
          </p>
        </Reveal>
      </div>

      {/* edge-to-edge scroller on mobile, grid on desktop */}
      <div className="flex snap-x gap-4 overflow-x-auto px-6 pb-3 md:container-luxe md:grid md:grid-cols-4 md:overflow-visible md:px-10 lg:grid-cols-5">
        {panels.map((p, i) => (
          <Reveal key={p.src} delay={i * 70} className="shrink-0 snap-start">
            <button
              onClick={() => setActive(i)}
              className="group block w-[62vw] overflow-hidden bg-charcoal sm:w-[42vw] md:w-full"
              aria-label={`View antique gold panel ${i + 1}`}
            >
              <img
                src={p.src}
                alt={`Culture Antique gold panel ${i + 1}`}
                loading="lazy"
                className="h-[240px] w-full object-cover object-top transition-transform duration-700 group-hover:scale-105 sm:h-[290px] md:h-[350px]"
              />
            </button>
          </Reveal>
        ))}
      </div>

      <Lightbox items={items} index={active} onClose={() => setActive(null)} onNavigate={setActive} />
    </section>
  );
}
